<div *ngIf="spinner==true">
    <ngx-spinner size="medium" type="timer">
        <p style="font-size: 20px; color: white;padding-left:7%;">Loading...</p>
    </ngx-spinner>
</div>
<div class="container-fluid">
    <div class="card">
        <div class="card-header">
            <div class="d-flex justify-content-between">
                <h4 class="font-weight-bold text-dark py">MENTOR</h4>
                <!-- <div style="width:120px">
                    <button type="button" class="btn btn-block btn-danger" data-toggle="modal" data-target="#myModal"
                        (click)="setCurrentdate()">Add</button>
                </div> -->
            </div>

        </div>
        <div *ngIf="!tableshow" class="d-flex justify-content-center">
            <div class="loader"></div>
        </div>
         <div class="p-3">
            <div class="table-responsive" *ngIf="tableshow">
                <table class="table table-bordered display" [dtOptions]="dtOptions" datatable width="100%"
                    cellspacing="0">
                    <thead>
                        <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>Email</th>
                            <th>Number</th>
                            <th>Show</th>
                            <th>Edit</th>
                            <th>Status</th>
                            <!-- <th>Delete</th> -->
                     
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let customer of customers">
                            <td style="min-width: 20px;">
                                {{customer.first_name}}
                            </td>
                       
                            <td style="min-width: 20px;">
                                {{customer.last_name}}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer.email }}
                            </td>
                            <td style="min-width: 20px;">
                                {{customer.number}}
                            </td>


                            <td><a data-toggle="modal" data-target="#showCM" class="btn btn-primary btn-circle btn-sm"
                                    (click)="buttonviewmeeting(customer,'show')">
                                    <i class="fas fa-flag"></i>
                                </a></td>
                       
                                <td><button data-toggle="modal" data-target="#showCM" [disabled]="customer.status=='cancel'"
                                    class="btn btn-primary btn-circle btn-sm" (click)="buttonviewmeeting(customer,'edit')">
                                    <i class="fas fa-check"></i>
                                </button></td>
                            <!-- <td><a class="btn btn-danger btn-circle btn-sm" (click)="delete_mentor(customer.id)">
                                <i class="fas fa-times"></i>  </a></td> -->
                               
                               <!-- Example component HTML template -->
<!-- Example component HTML template -->
<td>
    <!-- <select class="form-control" (change)="approve_Mentor(customer.id, $event)" [class.approve]="selectedAction === 'Approve'" [class.reject]="selectedAction === 'Reject'">
        <option value="" selected disabled>
            {{this.customers.status}}
        </option>
        <option *ngIf="customer.status !== 'Approve'" value="Approve">Approve</option>
        <option *ngIf="customer.status !== 'Reject'" value="Reject">Reject</option>
    </select> -->
    <select class="form-control" (change)="approve_Mentor(customer.id, $event)">
        <option [value]="customer.status" selected>{{customer.status}}</option>
        <option *ngIf="customer.status !== 'Active'" value="Active">Active</option>
        <option *ngIf="customer.status !== 'Inactive'" value="Inactive">Inactive</option>
    </select>
    
    
    
</td>  


                                
                                
                                
                            <ng-template #notShow>
                                <a *ngIf="customer.status=='cancel'">
                                    Cancelled

                                </a>
                            </ng-template>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div> 

    




        <div class="modal fade" id="showCM">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="card-primary">
                        <div class="card-header newcolor1">
                            <h3 class="card-title" id="card_title"></h3>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="card-body">
                            <form class="register-form" [formGroup]='editmeetingform'
                                (ngSubmit)="updatedata(editmeetingform,Mentor_id)" autocomplete="off">
                               
                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500"> First Name  <span class="pull-right"> :</span></h6>
                                       
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                       Mentor_name    }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Last Name <span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 Mentor_last_name  }}</h6>
                            </div>
                        </div>

                                </div>

                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500"> Email  <span class="pull-right"> :</span></h6>
                                       
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                       Mentor_email    }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row" >
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">WhatsApp Number <span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 Mentor_number  }}</h6>
                            </div>
                        </div>

                                </div>


                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row" >
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500"> Academic Details  <span class="pull-right"> :</span></h6>
                                       
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                       Mentor_education    }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Branch <span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 Mentor_branch  }}</h6>
                            </div>
                        </div>

                                </div>

                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500"> District  <span class="pull-right"> :</span></h6>
                                       
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                       Mentor_district    }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Activity  <span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 Mentor_activity  }}</h6>
                            </div>
                        </div>

                                </div>

                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500"> Area of Expertise  <span class="pull-right"> :</span></h6>
                                       
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                       Mentor_area    }}</h6>
                                </div>
                            </div>
                            <div class="col-6 col-sm-12 col-md-6 row">
                                <div class="col-sm-6 col-6" >
                                    <h6 class="f-w-500">Courses Volunteering  <span class="pull-right"> :</span></h6>
                                   
                                </div>
                                <div class="col-sm-6 col-6"><h6>{{
                                 Mentor_courses  }}</h6>
                            </div>
                        </div>

                                </div>
                                
                                <div class= "row mb-2" *ngIf="!editfield" >
                                    <div class="col-6 col-sm-12 col-md-6 row">
                                        <div class="col-sm-6 col-6" >
                                        <h6 class="f-w-500"> Status <span class="pull-right"> :</span></h6>
                                       
                                    </div>
                                    <div class="col-sm-6 col-6"><h6>{{
                                       Mentor_status    }}</h6>
                                </div>
                            </div>
                            <div class="col-6 row">
                                <div class="col-sm-6 mb-3 mb-sm-0" *ngIf="Mentor_image !=='' && !editfield">
                                    <label>Image <span class="required "> *</span></label>
                                    <img src="https://myroots.redmindtechnologies.com/api/{{Mentor_image}}"
                                        style="width:100px;height:100px;display:block" />

                                </div>
                        </div>

                                </div>
                             
                                <!-- <div class="form-group row" *ngIf="!editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Status <span class="required "> *</span></label>
                                        <input readonly [value]="Mentor_status" pInputText type="text" class="form-control"
                                            formControlName="status" placeholder="Enter Status"
                                            required>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6 mb-3 mb-sm-0" *ngIf="Mentor_image !=='' && !editfield">
                                        <label>Image <span class="required "> *</span></label>
                                        <img src="https://redmindtechnologies.com/dmk_php-dhanasekar/{{Mentor_image}}"
                                            style="width:100px;height:100px;display:block" />

                                    </div>
                                </div> -->
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>First Name </label><span class="required "> *</span>
                                        <input pInputText type="text" class="form-control" [value]="Mentor_name"
                                            formControlName="first_name" placeholder="Enter First Name / முதல் பெயர்">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label> Last Name </label><span class="required "> *</span>
                                        <input pInputText type="text" class="form-control" [value]="Mentor_last_name"
                                            formControlName="last_name" placeholder="Enter  Last Name /கடைசி பெயர்">

                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">

                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Email <span class="required "> *</span></label>
                                        <input pInputText type="email" class="form-control" [value]="Mentor_email"
                                            formControlName="email" placeholder="Enter Email / மின்னஞ்சல்">

                                    </div>
                                    <div class="col-sm-6">
                                        <label>WhatsApp Number<span class="required "> *</span></label>
                                        <input pInputText type="text" class="form-control" formControlName="number"
                                            [value]="Mentor_number" placeholder="Enter WhatsApp Number/வாட்ஸ்அப் எண்"
                                            required />

                                    </div>
                                </div>

                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Academic Details<span class="required ">
                                                *</span></label>
                                        <input pInputText type="text" class="form-control" [value]="Mentor_education"
                                            formControlName="education"
                                            placeholder="Enter Academic Details/கல்வித் தகுதி">

                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Branch<span class="required ">
                                                *</span></label>
                                        <input pInputText type="email" class="form-control" [value]="Mentor_branch"
                                            formControlName="branch" placeholder="Enter Branch/கிளை">

                                    </div>
                                </div>


                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>District <span class="required ">
                                                *</span></label><br>
                                        <!-- <select class="form-control" formControlName="district" [(ngModel)]="district"
                                            #mydst (change)="getChangeToConstituey(mydst.value)"> -->
                                            <select class="form-control" formControlName="district" [(ngModel)]="Mentor_district"
                                            >
                                            <option value="" selected disabled hidden>Select District</option>
                                            <option *ngFor="let option of district_list" [ngValue]="option">
                                                {{option}}</option>
                                        </select>

                                    </div>
                                    <!-- <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Constituency <span class="required ">
                                                *</span></label>
                                        <select class="form-control" formControlName="constituency"
                                            [(ngModel)]="Mentor_constituency">
                                            <option value="" selected disabled>Select constituency</option>
                                            <option *ngFor="let option of user_constituency" [ngValue]="option">
                                                {{option}}</option>
                                        </select>
                                    </div> -->
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Activity <span class="required ">
                                                *</span></label>
                                                <select class="form-control" formControlName="activity" [(ngModel)]="Mentor_activity">
                                                    <option>Mentoring</option>
                                                    <option>Presenting</option>
                                                    <option>Speech</option>

                                                </select>
                                    </div>

                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Area of Expertise<span class="required ">
                                                *</span></label>
                                        <input [value]="Mentor_area" pInputText type="text" class="form-control"
                                            formControlName="area"
                                            placeholder="Enter Area of Expertise/நிபுணத்துவப் பகுதி" required>
                                    </div>
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Courses Volunteering<span class="required ">
                                                *</span></label>
                                        <input readonly pInputText type="text" class="form-control" [value]="Mentor_courses"
                                            formControlName="courses"
                                            placeholder="Enter Courses Volunteering/படிப்புகள் தன்னார்வத் தொண்டு ">
                                    </div>
                                </div>
                                <div class="form-group row" *ngIf="editfield">
                                    <div class="col-sm-6 mb-3 mb-sm-0">
                                        <label>Status<span class="required "> *</span></label>
                                        <select class="form-control" formControlName="status" required
                                            [(ngModel)]="Mentor_status">
                                            <option value="Active">Active</option>
                                            <option value="Inactive">Inactive</option>


                                        </select>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6 mb-3 mb-sm-0" *ngIf="Mentor_image !==''&& editfield">
                                        <label>Image <span class="required "> *</span></label>
                                        <img src="https://myroots.redmindtechnologies.com/api/{{Mentor_image}}"
                                            style="width:100px;height:100px;display:block" />

                                    </div>
                                    <div class="col-md-6" *ngIf="editfield">
                                        <label>Photo<span class="required">*</span></label>
                                        <input type="file" class="form-control" formControlName="image"
                                            (change)="selectFiles($event)" />
                                    </div>
                                </div>



                                <div *ngIf="editfield" class="d-flex justify-content-center" style="margin-top: 5%;">
                                    <div style="width:200px">
                                        <button class="btn btn-primary btn btn-block">Update </button>
                                    </div>
                                </div>

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>